export const DATE_PERIOD_DAY = "date-period-day";
export const DATE_PERIOD_WEEK = "date-period-week";
export const DATE_PERIOD_MONTH = "date-period-month";
